
import type { PropType } from 'vue';

import {
  defineComponent,
  defineAsyncComponent,
} from 'vue';

import type {
  GenericObject,
  EntriesPaginator,
  Statistics,
} from '@/types';

import useEntriesNext from '@/composable/useEntries@next';

import useClipboard from '@/composable/useClipboard';

import useCampaignSubids from '@/composable/useCampaignSubids';

export default defineComponent({
  components: {
    ViewsColumn: defineAsyncComponent(() => import('@/components/Statistics/Advertiser/Columns/ViewsColumn.vue')),
    CampaignSubidControls: defineAsyncComponent(() => import('@/components/CampaignSubidControls.vue')),
  },
  props: {
    statisticsFilters: {
      type: Object as PropType<GenericObject>,
      required: true,
    },
    filters: {
      type: Object as PropType<GenericObject>,
      required: true,
    },
  },
  setup(props) {
    const {
      entries: statistics,
      entriesLoading: statisticsLoading,
      entriesFetched: statisticsFetched,
      fetchEntries: fetchStatistics,
    } = useEntriesNext<Statistics>('/api/statistics/advertiser/getStatisticsBySubids');

    const { copyToClipboard } = useClipboard();

    const campaignSubids = useCampaignSubids(props.statisticsFilters);

    const fetchStatisticsWrapper = async (subidsPaginator: EntriesPaginator): Promise<[void, void]> => Promise.all([
      fetchStatistics({
        ...props.statisticsFilters,
        ...props.filters,
        ...subidsPaginator,
      }),
      campaignSubids.fetchSettings(),
    ]);

    const getStatisticRowClass = (data: GenericObject): string => campaignSubids.subidRowClass(data.subid_uuid);

    return {
      statistics,
      statisticsLoading,
      statisticsFetched,
      copyToClipboard,
      campaignSubids,
      fetchStatisticsWrapper,
      getStatisticRowClass,
    };
  },
});
